<!-- Название раздела; сами разделы — в боковом меню. У расчётов и поставок заголовок свой, внутри списка -->
<app-ff-cabinet-head *ngIf="activeTab === 'requests' || activeTab === 'deals' || activeTab === 'supplies'" [titleKey]="tabTitle.key" [titleFallback]="tabTitle.fallback"></app-ff-cabinet-head>

<!-- Мои запросы -->
<section *ngIf="activeTab === 'requests'" class="pp-card">
  <!-- Фильтр: статус чипами, период — справа -->
  <div class="co-filter">
    <div class="co-filter__chips" role="tablist">
      <button type="button" *ngFor="let f of statusFilters" role="tab" class="co-chip"
              [class.is-active]="selectedStatus === f.value" [attr.aria-selected]="selectedStatus === f.value"
              (click)="setStatusFilter(f.value)">
        {{ t(f.key, f.fallback) }}
      </button>
    </div>
    <div class="co-filter__dates">
      <app-assignee-filter *ngIf="showManagerColumn" kind="manager" [value]="requestManagerFilter"
                           (changed)="onRequestManagerFilter($event)"></app-assignee-filter>
      <label>
        <span>{{ t('coDash.from', 'с') }}</span>
        <input type="date" [(ngModel)]="dateFrom" (change)="applyFilters()" />
      </label>
      <label>
        <span>{{ t('coDash.to', 'по') }}</span>
        <input type="date" [(ngModel)]="dateTo" (change)="applyFilters()" />
      </label>
      <button type="button" class="co-filter__reset" *ngIf="hasActiveFilters()" (click)="clearFilters()">
        {{ clearFiltersText }}
      </button>
      <a class="co-filter__new" routerLink="/cargo-owner/create-request">+ {{ createRequestText }}</a>
    </div>
  </div>

  <div *ngIf="loadingRequests" class="pp-loading">{{ loadingText }}</div>
  <div *ngIf="errorRequests" class="pp-error">{{ errorRequests }}</div>

  <div *ngIf="!loadingRequests && !errorRequests && requests.length === 0" class="pp-empty co-empty">
    <p>{{ hasActiveFilters() ? t('coDash.noMatches', 'Под фильтр ничего не подошло') : noRequestsText }}</p>
    <a *ngIf="!hasActiveFilters()" routerLink="/cargo-owner/create-request" class="co-empty__btn">+ {{ createRequestText }}</a>
  </div>

  <ng-container *ngIf="!loadingRequests && !errorRequests && requests.length > 0">
    <div class="pp-table-wrap">
      <table class="pp-table co-table co-requests" appResizableColumns="co-requests">
        <thead>
          <tr>
            <th>{{ t('coDash.request', 'Запрос') }}</th>
            <th>{{ routeText }}</th>
            <th>{{ t('coDash.cargo', 'Груз') }}</th>
            <th>{{ t('coDash.bids', 'Ставки') }}</th>
            <th *ngIf="showManagerColumn">{{ t('company.assign.managerColumn', 'Менеджер') }}</th>
            <th>{{ statusText }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of requests" class="co-row" (click)="viewRequest(request.id)">
            <td class="co-doc">
              <span class="co-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/></svg></span>
              <div>
                <strong>{{ request.id | docNo:'R':request.createdAt }}</strong>
                <span>{{ formatDate(request.createdAt) }}</span>
              </div>
            </td>
            <td class="route-cell">
              <strong [attr.title]="request.fromCity + ' → ' + request.toCity">{{ request.fromCity }} → {{ request.toCity }}</strong>
              <span>{{ countryName(request.fromCountryId) }} → {{ countryName(request.toCountryId) }}</span>
            </td>
            <td class="co-cargo">
              <strong>{{ formatWeight(getTotalWeight(request)) }}</strong>
              <span>{{ formatVolume(getTotalVolume(request)) }}</span>
            </td>
            <td>
              <span class="co-bids" *ngIf="request.bidsCount; else noBids">{{ bidsLabel(request.bidsCount) }}</span>
              <ng-template #noBids><span class="pp-muted">{{ request.isDraft ? '—' : awaitingBidText }}</span></ng-template>
            </td>
            <td *ngIf="showManagerColumn" class="pp-nowrap">{{ request.assignedManagerName || '—' }}</td>
            <td>
              <span class="pp-badge" [ngClass]="'pp-badge--' + requestTone(request)">{{ requestStatusText(request) }}</span>
            </td>
            <td class="pp-right">
              <span class="row-arrow" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination
      *ngIf="requestsPage"
      [number]="requestsPage.number"
      [totalPages]="requestsPage.totalPages"
      [size]="requestsPage.size"
      [totalElements]="requestsPage.totalElements"
      [hasNext]="requestsPage.hasNext"
      [hasPrevious]="requestsPage.hasPrevious"
      (pageChange)="onRequestsPageChange($event)"
    ></app-pagination>
  </ng-container>
</section>

<!-- Мои сделки -->
<section *ngIf="activeTab === 'deals'" class="pp-card">
  <div class="co-filter" *ngIf="showOperatorColumn">
    <div class="co-filter__dates">
      <app-assignee-filter *ngIf="showManagerColumn" kind="manager" [value]="dealManagerFilter"
                           (changed)="dealManagerFilter = $event; onDealFilterChange()"></app-assignee-filter>
      <app-assignee-filter kind="operator" [value]="dealOperatorFilter"
                           (changed)="dealOperatorFilter = $event; onDealFilterChange()"></app-assignee-filter>
    </div>
  </div>
  <div *ngIf="loadingDeals" class="pp-loading">{{ loadingText }}</div>
  <div *ngIf="errorDeals" class="pp-error">{{ errorDeals }}</div>
  <div *ngIf="!loadingDeals && !errorDeals && deals.length === 0" class="pp-empty">{{ noDealsText }}</div>

  <ng-container *ngIf="!loadingDeals && !errorDeals && deals.length > 0">
    <div class="pp-table-wrap">
      <table class="pp-table co-table co-deals" appResizableColumns="co-deals">
        <thead>
          <tr>
            <th>{{ t('coDash.deal', 'Сделка') }}</th>
            <th>{{ t('ffDash.requestRoute', 'Запрос и маршрут') }}</th>
            <th>{{ freightForwarderText }}</th>
            <th>{{ t('ffDash.price', 'Ставка') }}</th>
            <th *ngIf="showManagerColumn">{{ t('company.assign.managerColumn', 'Менеджер') }}</th>
            <th *ngIf="showOperatorColumn">{{ t('company.assign.operatorColumn', 'Оператор') }}</th>
            <th>{{ t('ffDash.stage', 'Текущий этап') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let deal of deals" class="co-row" (click)="viewDeal(deal.id)">
            <td class="co-doc">
              <span class="co-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>
              <div>
                <strong>{{ deal.id | docNo:'D':deal.createdAt }}</strong>
                <span>{{ formatDate(deal.createdAt) }}</span>
              </div>
            </td>
            <td class="route-cell">
              <ng-container *ngIf="dealInfo[deal.id] as info; else dealLoading">
                <small>{{ deal.cargoRequestId | docNo:'R':info.requestCreatedAt }}</small>
                <strong [attr.title]="info.route">{{ info.route }}</strong>
                <span>{{ info.countries }}</span>
              </ng-container>
              <ng-template #dealLoading><span class="pp-muted">…</span></ng-template>
            </td>
            <td class="co-company">{{ deal.freightForwarderCompanyName }}</td>
            <td class="pp-num pp-nowrap">
              <ng-container *ngIf="dealInfo[deal.id] as info">{{ info.price }}</ng-container>
            </td>
            <td *ngIf="showManagerColumn" class="pp-nowrap">{{ deal.managerName || '—' }}</td>
            <td *ngIf="showOperatorColumn" class="pp-nowrap">{{ deal.operatorName || '—' }}</td>
            <td class="stage-cell">
              <ng-container *ngIf="dealInfo[deal.id] as info">
                <strong class="co-stage">{{ info.stage }}</strong>
                <span *ngIf="info.stageDate">{{ formatDate(info.stageDate) }}</span>
              </ng-container>
            </td>
            <td class="pp-right">
              <span class="row-arrow" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination
      *ngIf="dealsPage"
      [number]="dealsPage.number"
      [totalPages]="dealsPage.totalPages"
      [size]="dealsPage.size"
      [totalElements]="dealsPage.totalElements"
      [hasNext]="dealsPage.hasNext"
      [hasPrevious]="dealsPage.hasPrevious"
      (pageChange)="onDealsPageChange($event)"
    ></app-pagination>
  </ng-container>
</section>

<!-- Мои расчёты -->
<div *ngIf="activeTab === 'calculations'">
  <app-calculations-list
    [calculations]="calculations"
    [calculationsPage]="calculationsPage"
    [loading]="loadingCalculations"
    [error]="errorCalculations"
    [showCreateButton]="true"
    [showDeleteButton]="true"
    [backRoute]="'/cargo-owner/dashboard/calculations'"
    (createCalculation)="onCreateCalculation()"
    (viewCalculation)="onViewCalculation($event)"
    (deleteCalculation)="onDeleteCalculation($event)"
    (pageChange)="onCalculationsPageChange($event)"
    (filterChange)="onCalculationsFilterChange($event)"
  ></app-calculations-list>
</div>

<!-- Мои поставки — расчёты на сопровождении: таблица как у запросов и сделок -->
<section *ngIf="activeTab === 'supplies'" class="pp-card">
  <div class="co-filter">
    <label class="co-filter__search">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
      <input type="search" [(ngModel)]="suppliesSearch" (keyup.enter)="applySuppliesFilters()" (search)="applySuppliesFilters()"
             [placeholder]="t('common.supplies.searchPlaceholder', 'Название расчёта, товар, инвойс...')" />
    </label>
    <div class="co-filter__dates">
      <label>
        <span>{{ t('coDash.from', 'с') }}</span>
        <input type="date" [(ngModel)]="suppliesDateFrom" (change)="applySuppliesFilters()" />
      </label>
      <label>
        <span>{{ t('coDash.to', 'по') }}</span>
        <input type="date" [(ngModel)]="suppliesDateTo" (change)="applySuppliesFilters()" />
      </label>
      <button type="button" class="co-filter__reset" *ngIf="hasSuppliesFilters()" (click)="clearSuppliesFilters()">
        {{ clearFiltersText }}
      </button>
    </div>
  </div>

  <div *ngIf="loadingSupplies" class="pp-loading">{{ loadingText }}</div>
  <div *ngIf="errorSupplies" class="pp-error">{{ errorSupplies }}</div>
  <div *ngIf="!loadingSupplies && !errorSupplies && supplies.length === 0 && filteredDealSupplies.length === 0" class="pp-empty">
    {{ hasSuppliesFilters() ? t('coDash.noMatches', 'Под фильтр ничего не подошло') : suppliesEmptyText }}
  </div>

  <ng-container *ngIf="!loadingSupplies && !errorSupplies && (supplies.length > 0 || filteredDealSupplies.length > 0)">
    <div class="pp-table-wrap">
      <table class="pp-table co-table co-supplies" appResizableColumns="co-supplies">
        <thead>
          <tr>
            <th>{{ t('common.supplies.colNumber', '№ поставки') }}</th>
            <th>{{ t('common.supplies.colProduct', 'Товар / Инвойс') }}</th>
            <th>{{ routeText }}</th>
            <th>{{ t('common.supplies.colCost', 'Стоимость товара') }}</th>
            <th>{{ t('coDash.customsPayments', 'Таможенные платежи') }}</th>
            <th>{{ statusText }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of supplies" class="co-row" (click)="onOpenSupply(s.id)">
            <td class="co-doc">
              <span class="co-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M21 8l-9-5-9 5v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg></span>
              <div>
                <strong>№ {{ s.id }}</strong>
                <span>{{ formatDate(s.createdAt) }}</span>
              </div>
            </td>
            <td class="route-cell">
              <strong [attr.title]="supplyProductsFull(s)">{{ supplyProducts(s) }}</strong>
              <span *ngIf="s.invoiceData?.invoiceNumber">{{ t('common.supplies.invoice', 'Инвойс') }} {{ s.invoiceData?.invoiceNumber }}</span>
            </td>
            <td class="route-cell">
              <ng-container *ngIf="s.fromCity || s.toCity || s.fromCountryName || s.toCountryName; else noRoute">
                <strong>{{ s.fromCity || s.fromCountryName || '—' }} → {{ s.toCity || s.toCountryName || '—' }}</strong>
                <span>{{ s.fromCountryName || '—' }} → {{ s.toCountryName || '—' }}</span>
              </ng-container>
              <ng-template #noRoute><span class="pp-muted">—</span></ng-template>
            </td>
            <td class="pp-num pp-nowrap">{{ kztMoney(s.totalProductCostKzt) }}</td>
            <td class="pp-num pp-nowrap">{{ kztMoney(s.totalCustomsPayments) }}</td>
            <td><span class="pp-badge pp-badge--blue">{{ t('common.supplies.statusInProcessing', 'В обработке') }}</span></td>
            <td class="pp-right">
              <span class="row-arrow" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg></span>
            </td>
          </tr>
          <!-- Сделки без расчёта — поставка по перевозке -->
          <tr *ngFor="let deal of filteredDealSupplies" class="co-row" (click)="openDealSupply(deal.id)">
            <td class="co-doc">
              <span class="co-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>
              <div>
                <strong>{{ deal.id | docNo:'D':deal.createdAt }}</strong>
                <span>{{ formatDate(deal.createdAt) }}</span>
              </div>
            </td>
            <td class="route-cell">
              <ng-container *ngIf="dealInfo[deal.id] as info; else supplyLoading">
                <strong [attr.title]="info.cargo">{{ info.cargo || '—' }}</strong>
                <span>{{ t('coDash.noCalc', 'Без расчёта') }} · {{ deal.freightForwarderCompanyName }}</span>
              </ng-container>
              <ng-template #supplyLoading><span class="pp-muted">…</span></ng-template>
            </td>
            <td class="route-cell">
              <ng-container *ngIf="dealInfo[deal.id] as info">
                <strong>{{ info.route }}</strong>
                <span>{{ info.countries }}</span>
              </ng-container>
            </td>
            <td class="pp-num pp-muted">—</td>
            <td class="pp-num pp-muted">—</td>
            <td><span class="pp-badge pp-badge--blue" *ngIf="dealInfo[deal.id] as info">{{ info.stage }}</span></td>
            <td class="pp-right">
              <span class="row-arrow" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination
      *ngIf="suppliesPage"
      [number]="suppliesPage.number"
      [totalPages]="suppliesPage.totalPages"
      [size]="suppliesPage.size"
      [totalElements]="suppliesPage.totalElements"
      [hasNext]="suppliesPage.hasNext"
      [hasPrevious]="suppliesPage.hasPrevious"
      (pageChange)="onSuppliesPageChange($event)"
    ></app-pagination>
  </ng-container>
</section>
